import React from "react";
import PropTypes from "prop-types";
import "./searchStyle.scss";
import styles from "./../../../assets/scss/custom.module.scss";
import { SearchText } from "../../../locales/en";

function SearchField({
  tempSearchQuery,
  handleSearchChange,
  handleKeyDown,
  placeHolderText = SearchText,
  loading
}) {
  return (
    <div className={styles.inputFilterBar}>
      <div className="modifiedSearch">
        <input
          className="rounded-0"
          type="search"
          value={tempSearchQuery}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          placeholder={placeHolderText}
          disabled={loading}
        />
        {tempSearchQuery && (
          <button
            type="button"
            onClick={() => handleSearchChange({ target: { value: "" } })}
            aria-label="Clear search"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}

SearchField.propTypes = {
  tempSearchQuery: PropTypes.string,
  handleSearchChange: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func,
  placeHolderText: PropTypes.string,
  loading: PropTypes.bool
};

export default SearchField;
